;(function (angular, _) {
  'use strict'

  class LedgerLineErrorController {
    // DI
    $rootScope
    $state
    productTypeManager
    ledgerService
    snackService
    // Locales
    selectedProductType = null
    productTypes = []
    loadProductTypes = false
    loading = false

    constructor (
      // Angular
      $rootScope, $state,
      // Libs
      // Managers
      ProductTypeManager,
      // Services
      LedgerService, SnackService
      // Const
      // Resolved
    ) {
      this.$rootScope = $rootScope
      this.$state = $state
      this.productTypeManager = ProductTypeManager
      this.ledgerService = LedgerService
      this.snackService = SnackService
    }

    $onInit () {
      this.searchProductType()
    }

    searchProductType (search = '') {
      this.loadProductTypes = true

      let query = this.productTypeManager.query({
        select: '_id label',
        limit: 10
      })
      if (search.trim().length) {
        query.setQuery({label: { $regex: `.*${search}.*`, $options: 'ig' }})
      }
      return this.productTypeManager.get(query).then(({ data }) => {
        this.productTypes = data
      }).finally(() => {
        this.loadProductTypes = false
      })
    }

    validate () {
      if (!this.selectedProductType?._id) {
        return
      }
      const kind = this.error.isCreditNote ? 'creditnote' : 'invoice'
      const id = this.error.invoice
      const lineId = this.error.lineObject._id
      const productType = this.selectedProductType._id
      this.loading = true
      return this.ledgerService.fixLine(kind, id, lineId, productType).then(() => {
        this.update()
      }).finally(() => {
        this.loading = false
      })
    }

    update () {
      this.$rootScope.$emit('ledger-line-error:fixed', this.error, this.kind)
      this.snackService.snack({
        text: 'Ligne corrigée',
        delay: 5000
      })
      this.selectedProductType = null
    }

    redirectToElement () {
      const state = this.error.isCreditNote ? 'creditnote.show' : 'invoice.show'

      const url = this.$state.href(state, { id: this.error.invoice })

      window.open(url, '_blank')
    }
  }

  LedgerLineErrorController.$inject = [
    // Angular
    '$rootScope', '$state',
    // Libs
    // Managers
    'ProductTypeManager',
    // Services
    'LedgerService', 'SnackService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .directive('ledgerLineError', () => {
      return {
        restrict: 'A',
        bindToController: {
          error: '=',
          number: '=',
          kind: '@'
        },
        controllerAs: '$ctrl',
        controller: LedgerLineErrorController,
        templateUrl: '/app/common/components/ledger-error-handler/ledger-line-error/ledger-line-error.template.html'
      }
    })
})(window.angular, window._)
